export const SEARCH_AS_I_MOVE: string = "SEARCH_AS_I_MOVE";
export const HIDE_GEOLOCATION_MODAL_ON_SEARCH_PAGE: string =
  "HIDE_GEOLOCATION_MODAL_ON_SEARCH_PAGE";
export const HIDE_GEOLOCATION_MODAL_ON_MAIN_PAGE: string = "HIDE_GEOLOCATION_MODAL_ON_MAIN_PAGE";
export const HIDE_GEOLOCATION_MODAL_EVERYWHERE: string = "HIDE_GEOLOCATION_MODAL_EVERYWHERE";
